export default {
  methods: {
    getUnits() {
      return [
        {
          code: "539",
          fullName: "Человеко-час",
          shortName: "чел.ч",
          shortNameCode: "ЧЕЛ.Ч"
        },
        {
          code: "055",
          fullName: "Квадратный метр",
          shortName: "м²",
          shortNameCode: "m²"
        },
        {
          code: "796",
          fullName: "Штука",
          shortName: "шт",
          shortNameCode: "pc; 1"
        },
        {
          code: "8751",
          fullName: "Коробка"
        },
        {
          code: "10001",
          fullName: "Услуга",
          shortName: "Услуга",
          shortNameCode: "Услуга"
        },
        {
          code: "113",
          fullName: "Кубический метр",
          shortName: "м³",
          shortNameCode: "m3"
        },
        {
          code: "003",
          fullName: "Миллиметр",
          shortName: "мм",
          shortNameCode: "mm"
        },
        {
          code: "004",
          fullName: "Сантиметр",
          shortName: "см",
          shortNameCode: "cm"
        },
        {
          code: "005",
          fullName: "Дециметр",
          shortName: "дм",
          shortNameCode: "dm"
        },
        {
          code: "006",
          fullName: "Метр",
          shortName: "м",
          shortNameCode: "m"
        },
        {
          code: "008",
          fullName: "Километр; тысяча метров",
          shortName: "км; 10³ м",
          shortNameCode: "km"
        },
        {
          code: "009",
          fullName: "Мегаметр; миллион метров",
          shortName: "Мм; 106 м",
          shortNameCode: "Mm"
        },
        {
          code: "015",
          fullName: "Нанометр",
          shortName: "нм",
          shortNameCode: "НМ"
        },
        {
          code: "018",
          fullName: "Погонный метр",
          shortName: "пог. м",
          shortNameCode: "ПОГ М"
        },
        {
          code: "019",
          fullName: "Тысяча погонных метров",
          shortName: "10³ пог. м",
          shortNameCode: "ТЫС ПОГ М"
        },
        {
          code: "020",
          fullName: "Условный метр",
          shortName: "усл. м",
          shortNameCode: "УСЛ М"
        },
        {
          code: "039",
          fullName: "Дюйм (25,4 мм)",
          shortName: "дюйм",
          shortNameCode: "in"
        },
        {
          code: "041",
          fullName: "Фут (0,3048 м)",
          shortName: "фут",
          shortNameCode: "ft"
        },
        {
          code: "043",
          fullName: "Ярд (0,9144 м)",
          shortName: "ярд",
          shortNameCode: "yd"
        },
        {
          code: "047",
          fullName: "Морская миля (1852 м)",
          shortName: "миля",
          shortNameCode: "n mile"
        },
        {
          code: "048",
          fullName: "Тысяча условных метров",
          shortName: "10³ усл. м",
          shortNameCode: "ТЫС УСЛ М"
        },
        {
          code: "049",
          fullName: "Километр условных труб",
          shortName: "км усл. труб",
          shortNameCode: "КМ УСЛ ТРУБ"
        },
        {
          code: "050",
          fullName: "Квадратный миллиметр",
          shortName: "мм²",
          shortNameCode: "mm²"
        },
        {
          code: "051",
          fullName: "Квадратный сантиметр",
          shortName: "см²",
          shortNameCode: "cm²"
        },
        {
          code: "053",
          fullName: "Квадратный дециметр",
          shortName: "дм²",
          shortNameCode: "dm²"
        },
        {
          code: "054",
          fullName: "Тысяча квадратных дециметров",
          shortName: "10³ дм²",
          shortNameCode: "ТЫС ДМ2"
        },
        {
          code: "056",
          fullName: "Миллион квадратных дециметров",
          shortName: "106 дм²",
          shortNameCode: "МЛН ДМ2"
        },
        {
          code: "057",
          fullName: "Миллион квадратных метров",
          shortName: "106 м²",
          shortNameCode: "МЛН М2"
        },
        {
          code: "058",
          fullName: "Тысяча квадратных метров",
          shortName: "10³ м²",
          shortNameCode: "daa"
        },
        {
          code: "059",
          fullName: "Гектар",
          shortName: "га",
          shortNameCode: "ha"
        },
        {
          code: "060",
          fullName: "Тысяча гектаров",
          shortName: "10³ га",
          shortNameCode: "ТЫС ГА"
        },
        {
          code: "061",
          fullName: "Квадратный километр",
          shortName: "км²",
          shortNameCode: "km²"
        },
        {
          code: "062",
          fullName: "Условный квадратный метр",
          shortName: "усл. м²",
          shortNameCode: "УСЛ М2"
        },
        {
          code: "063",
          fullName: "Тысяча условных квадратных метров",
          shortName: "10³ усл. м²",
          shortNameCode: "ТЫС УСЛ М2"
        },
        {
          code: "064",
          fullName: "Миллион условных квадратных метров",
          shortName: "106 усл. м²",
          shortNameCode: "МЛН УСЛ М2"
        },
        {
          code: "071",
          fullName: "Квадратный дюйм (645,16 мм2)",
          shortName: "дюйм²",
          shortNameCode: "in²"
        },
        {
          code: "073",
          fullName: "Квадратный фут (0,092903 м2)",
          shortName: "фут²",
          shortNameCode: "ft²"
        },
        {
          code: "075",
          fullName: "Квадратный ярд (0,8361274 м2)",
          shortName: "ярд²",
          shortNameCode: "yd²"
        },
        {
          code: "081",
          fullName: "Квадратный метр общей площади",
          shortName: "м² общ. пл",
          shortNameCode: "М2 ОБЩ ПЛ"
        },
        {
          code: "082",
          fullName: "Тысяча квадратных метров общей площади",
          shortName: "10³ м² общ. пл",
          shortNameCode: "ТЫС М2 ОБЩ ПЛ"
        },
        {
          code: "083",
          fullName: "Миллион квадратных метров общей площади",
          shortName: "106 м² общ. пл",
          shortNameCode: "МЛН М2. ОБЩ ПЛ"
        },
        {
          code: "084",
          fullName: "Квадратный метр жилой площади",
          shortName: "м² жил. пл",
          shortNameCode: "М2 ЖИЛ ПЛ"
        },
        {
          code: "085",
          fullName: "Тысяча квадратных метров жилой площади",
          shortName: "10³ м² жил. пл",
          shortNameCode: "ТЫС М2 ЖИЛ ПЛ"
        },
        {
          code: "086",
          fullName: "Миллион квадратных метров жилой площади",
          shortName: "106 м² жил. пл",
          shortNameCode: "МЛН М2 ЖИЛ ПЛ"
        },
        {
          code: "087",
          fullName: "Квадратный метр учебно-лабораторных зданий",
          shortName: "м² уч. лаб. здан",
          shortNameCode: "М2 УЧ.ЛАБ ЗДАН"
        },
        {
          code: "088",
          fullName: "Тысяча квадратных метров учебно-лабораторных зданий",
          shortName: "10³ м² уч. лаб. здан",
          shortNameCode: "ТЫС М2 УЧ. ЛАБ ЗДАН"
        },
        {
          code: "089",
          fullName: "Миллион квадратных метров в двухмиллиметровом исчислении",
          shortName: "106 м² 2 мм исч",
          shortNameCode: "МЛН М2 2ММ ИСЧ"
        },
        {
          code: "109",
          fullName: "Ар (100 м2)",
          shortName: "а",
          shortNameCode: "a"
        },
        {
          code: "110",
          fullName: "Кубический миллиметр",
          shortName: "мм³",
          shortNameCode: "mm³"
        },
        {
          code: "111",
          fullName: "Кубический сантиметр; миллилитр",
          shortName: "см³; мл",
          shortNameCode: "cm³; ml"
        },
        {
          code: "112",
          fullName: "Литр; кубический дециметр",
          shortName: "л; дм³",
          shortNameCode: "I; L; dm³"
        },
        {
          code: "114",
          fullName: "Тысяча кубических метров",
          shortName: "10³ м³",
          shortNameCode: "ТЫС М3"
        },
        {
          code: "115",
          fullName: "Миллиард кубических метров",
          shortName: "109 м³",
          shortNameCode: "МЛРД М3"
        },
        {
          code: "116",
          fullName: "Декалитр",
          shortName: "дкл",
          shortNameCode: "ДКЛ"
        },
        {
          code: "118",
          fullName: "Децилитр",
          shortName: "дл",
          shortNameCode: "dl"
        },
        {
          code: "119",
          fullName: "Тысяча декалитров",
          shortName: "10³ дкл",
          shortNameCode: "ТЫС ДКЛ"
        },
        {
          code: "120",
          fullName: "Миллион декалитров",
          shortName: "106 дкл",
          shortNameCode: "МЛН ДКЛ"
        },
        {
          code: "121",
          fullName: "Плотный кубический метр",
          shortName: "плотн. м³",
          shortNameCode: "ПЛОТН М3"
        },
        {
          code: "122",
          fullName: "Гектолитр",
          shortName: "гл",
          shortNameCode: "hl"
        },
        {
          code: "123",
          fullName: "Условный кубический метр",
          shortName: "усл. м³",
          shortNameCode: "УСЛ М3"
        },
        {
          code: "124",
          fullName: "Тысяча условных кубических метров",
          shortName: "10³ усл. м³",
          shortNameCode: "ТЫС УСЛ М3"
        },
        {
          code: "125",
          fullName: "Миллион кубических метров переработки газа",
          shortName: "106 м³ пере-раб. газа",
          shortNameCode: "МЛН М3 ПЕРЕРАБ ГАЗА"
        },
        {
          code: "126",
          fullName: "Мегалитр",
          shortName: "Мл",
          shortNameCode: "Ml"
        },
        {
          code: "127",
          fullName: "Тысяча плотных кубических метров",
          shortName: "10³ плотн. м³",
          shortNameCode: "ТЫС ПЛОТН М3"
        },
        {
          code: "128",
          fullName: "Тысяча полулитров",
          shortName: "10³ пол. л",
          shortNameCode: "ТЫС ПОЛ Л"
        },
        {
          code: "129",
          fullName: "Миллион полулитров",
          shortName: "106 пол. л",
          shortNameCode: "МЛН ПОЛ Л"
        },
        {
          code: "130",
          fullName: "Тысяча литров; 1000 литров",
          shortName: "10³ л; 1000 л",
          shortNameCode: "ТЫС Л"
        },
        {
          code: "131",
          fullName: "Кубический дюйм (16387,1 мм3)",
          shortName: "дюйм³",
          shortNameCode: "in3"
        },
        {
          code: "132",
          fullName: "Кубический фут (0,02831685 м3)",
          shortName: "фут³",
          shortNameCode: "ft3"
        },
        {
          code: "133",
          fullName: "Кубический ярд (0,764555 м3)",
          shortName: "ярд³",
          shortNameCode: "yd3"
        },
        {
          code: "159",
          fullName: "Миллион кубических метров",
          shortName: "106 м³",
          shortNameCode: "106 m3"
        },
        {
          code: "160",
          fullName: "Гектограмм",
          shortName: "гг",
          shortNameCode: "hg"
        },
        {
          code: "161",
          fullName: "Миллиграмм",
          shortName: "мг",
          shortNameCode: "mg"
        },
        {
          code: "162",
          fullName: "Метрический карат (1 карат=200 мг=2.10[-4*] кг)",
          shortName: "кар",
          shortNameCode: "МС"
        },
        {
          code: "163",
          fullName: "Грамм",
          shortName: "г",
          shortNameCode: "g"
        },
        {
          code: "164",
          fullName: "Микрограмм"
        },
        {
          code: "165",
          fullName: "Тысяча каратов метрических",
          shortName: "10³ кар",
          shortNameCode: "ТЫС КАР"
        },
        {
          code: "166",
          fullName: "Килограмм",
          shortName: "кг",
          shortNameCode: "kg"
        },
        {
          code: "167",
          fullName: "Миллион каратов метрических",
          shortName: "106 кар",
          shortNameCode: "МЛН КАР"
        },
        {
          code: "168",
          fullName: "Тонна; метрическая тонна (1000 кг)",
          shortName: "т",
          shortNameCode: "t"
        },
        {
          code: "169",
          fullName: "Тысяча тонн",
          shortName: "10³ т",
          shortNameCode: "ТЫС Т"
        },
        {
          code: "170",
          fullName: "Килотонна",
          shortName: "10³ т",
          shortNameCode: "kt"
        },
        {
          code: "171",
          fullName: "Миллион тонн",
          shortName: "106 т",
          shortNameCode: "МЛН Т"
        },
        {
          code: "172",
          fullName: "Тонна условного топлива",
          shortName: "т усл. топл",
          shortNameCode: "Т УСЛ ТОПЛ"
        },
        {
          code: "173",
          fullName: "Сантиграмм",
          shortName: "сг",
          shortNameCode: "cg"
        },
        {
          code: "175",
          fullName: "Тысяча тонн условного топлива",
          shortName: "10³ т усл. топл",
          shortNameCode: "ТЫС Т УСЛ ТОПЛ"
        },
        {
          code: "176",
          fullName: "Миллион тонн условного топлива",
          shortName: "106 т усл. топл",
          shortNameCode: "МЛН Т УСЛ ТОПЛ"
        },
        {
          code: "177",
          fullName: "Тысяча тонн единовременного хранения",
          shortName: "10³ т единовр. хран",
          shortNameCode: "ТЫС Т ЕДИНОВР ХРАН"
        },
        {
          code: "178",
          fullName: "Тысяча тонн переработки",
          shortName: "10³ т перераб",
          shortNameCode: "ТЫС Т ПЕРЕРАБ"
        },
        {
          code: "179",
          fullName: "Условная тонна",
          shortName: "усл. т",
          shortNameCode: "УСЛ Т"
        },
        {
          code: "181",
          fullName: "Брутто-регистровая тонна (2,8316 м[3*])",
          shortName: "БРТ",
          shortNameCode: "-"
        },
        {
          code: "185",
          fullName: "Грузоподъемность в метрических тоннах",
          shortName: "т грп",
          shortNameCode: "-"
        },
        {
          code: "206",
          fullName: "Центнер (метрический) (100 кг); гектокилограмм; квинтал[*] (метрический); децитоннах",
          shortName: "ц",
          shortNameCode: "q; 102 kg"
        },
        {
          code: "207",
          fullName: "Тысяча центнеров",
          shortName: "10³ ц",
          shortNameCode: "ТЫС Ц"
        },
        {
          code: "212",
          fullName: "Ватт",
          shortName: "Вт",
          shortNameCode: "W"
        },
        {
          code: "214",
          fullName: "Киловатт",
          shortName: "кВт",
          shortNameCode: "kW"
        },
        {
          code: "215",
          fullName: "Мегаватт; тысяча киловатт",
          shortName: "10³ кВт",
          shortNameCode: "ТЫС КВТ"
        },
        {
          code: "222",
          fullName: "Вольт",
          shortName: "В",
          shortNameCode: "V"
        },
        {
          code: "223",
          fullName: "Киловольт",
          shortName: "кВ",
          shortNameCode: "kV"
        },
        {
          code: "226",
          fullName: "Вольт-ампер",
          shortName: "В.А",
          shortNameCode: "В.А"
        },
        {
          code: "227",
          fullName: "Киловольт-ампер",
          shortName: "кВ.А",
          shortNameCode: "kV.A"
        },
        {
          code: "228",
          fullName: "Мегавольт-ампер (тысяча киловольт-ампер)",
          shortName: "МВ.А",
          shortNameCode: "MV.A"
        },
        {
          code: "230",
          fullName: "Киловар",
          shortName: "квар",
          shortNameCode: "kVAR"
        },
        {
          code: "231",
          fullName: "Метр в час",
          shortName: "м/ч",
          shortNameCode: "М/Ч"
        },
        {
          code: "232",
          fullName: "Килокалория",
          shortName: "ккал",
          shortNameCode: "ККАЛ"
        },
        {
          code: "233",
          fullName: "Гигакалория",
          shortName: "Гкал",
          shortNameCode: "ГИГАКАЛ"
        },
        {
          code: "234",
          fullName: "Тысяча гигакалорий",
          shortName: "10³ Гкал",
          shortNameCode: "ТЫС ГИГАКАЛ"
        },
        {
          code: "235",
          fullName: "Миллион гигакалорий",
          shortName: "106 Гкал",
          shortNameCode: "МЛН ГИГАКАЛ"
        },
        {
          code: "236",
          fullName: "Калория в час",
          shortName: "кал/ч",
          shortNameCode: "КАЛ/Ч"
        },
        {
          code: "237",
          fullName: "Килокалория в час",
          shortName: "ккал/ч",
          shortNameCode: "ККАЛ/Ч"
        },
        {
          code: "238",
          fullName: "Гигакалория в час",
          shortName: "Гкал/ч",
          shortNameCode: "ГИГАКАЛ/Ч"
        },
        {
          code: "239",
          fullName: "Тысяча гигакалорий в час",
          shortName: "10³ Гкал/ч",
          shortNameCode: "ТЫС ГИГАКАЛ/Ч"
        },
        {
          code: "241",
          fullName: "Миллион ампер-часов",
          shortName: "106 А.ч",
          shortNameCode: "МЛН А.Ч"
        },
        {
          code: "242",
          fullName: "Миллион киловольт-ампер",
          shortName: "106 кВ.А",
          shortNameCode: "МЛН КВ.А"
        },
        {
          code: "243",
          fullName: "Ватт-час",
          shortName: "Вт.ч",
          shortNameCode: "W.h"
        },
        {
          code: "245",
          fullName: "Киловатт-час",
          shortName: "кВт.ч",
          shortNameCode: "kW.h"
        },
        {
          code: "246",
          fullName: "Мегаватт-час; 1000 киловатт-часов",
          shortName: "МВт.ч; 10³ кВт.ч",
          shortNameCode: "МW.h"
        },
        {
          code: "247",
          fullName: "Гигаватт-час (миллион киловатт-часов)",
          shortName: "ГВт.ч",
          shortNameCode: "GW.h"
        },
        {
          code: "248",
          fullName: "Киловольт-ампер реактивный",
          shortName: "кВ.А Р",
          shortNameCode: "КВ.А Р"
        },
        {
          code: "249",
          fullName: "Миллиард киловатт-часов",
          shortName: "109 кВт.ч",
          shortNameCode: "МЛРД КВТ.Ч"
        },
        {
          code: "250",
          fullName: "Тысяча киловольт-ампер реактивных",
          shortName: "10³ кВ.А Р",
          shortNameCode: "ТЫС КВ.А Р"
        },
        {
          code: "251",
          fullName: "Лошадиная сила",
          shortName: "л. с",
          shortNameCode: "ЛС"
        },
        {
          code: "252",
          fullName: "Тысяча лошадиных сил",
          shortName: "10³ л. с",
          shortNameCode: "ТЫС ЛС"
        },
        {
          code: "253",
          fullName: "Миллион лошадиных сил",
          shortName: "106 л. с",
          shortNameCode: "МЛН ЛС"
        },
        {
          code: "254",
          fullName: "Бит",
          shortName: "бит",
          shortNameCode: "БИТ"
        },
        {
          code: "255",
          fullName: "Байт",
          shortName: "бай",
          shortNameCode: "БАЙТ"
        },
        {
          code: "256",
          fullName: "Килобайт",
          shortName: "кбайт",
          shortNameCode: "КБАЙТ"
        },
        {
          code: "257",
          fullName: "Мегабайт",
          shortName: "Мбайт",
          shortNameCode: "МБАЙТ"
        },
        {
          code: "258",
          fullName: "Бод",
          shortName: "бод",
          shortNameCode: "БОД"
        },
        {
          code: "260",
          fullName: "Ампер",
          shortName: "А",
          shortNameCode: "A"
        },
        {
          code: "263",
          fullName: "Ампер-час (3,6 кКл)",
          shortName: "А.ч",
          shortNameCode: "A.h"
        },
        {
          code: "264",
          fullName: "Тысяча ампер-часов",
          shortName: "10³ А.ч",
          shortNameCode: "103 A.h"
        },
        {
          code: "270",
          fullName: "Кулон",
          shortName: "Кл",
          shortNameCode: "C"
        },
        {
          code: "271",
          fullName: "Джоуль",
          shortName: "Дж",
          shortNameCode: "J"
        },
        {
          code: "273",
          fullName: "Килоджоуль",
          shortName: "кДж",
          shortNameCode: "kJ"
        },
        {
          code: "274",
          fullName: "Ом",
          shortName: "Ом",
          shortNameCode: "&lt;омега&gt;"
        },
        {
          code: "280",
          fullName: "Градус Цельсия",
          shortName: "град. C",
          shortNameCode: "град. C"
        },
        {
          code: "281",
          fullName: "Градус Фаренгейта",
          shortName: "град. F",
          shortNameCode: "град. F"
        },
        {
          code: "282",
          fullName: "Кандела",
          shortName: "кд",
          shortNameCode: "cd"
        },
        {
          code: "283",
          fullName: "Люкс",
          shortName: "лк",
          shortNameCode: "lx"
        },
        {
          code: "284",
          fullName: "Люмен",
          shortName: "лм",
          shortNameCode: "lm"
        },
        {
          code: "287",
          fullName: "Генри",
          shortName: "Гн",
          shortNameCode: "ГН"
        },
        {
          code: "288",
          fullName: "Кельвин",
          shortName: "K",
          shortNameCode: "K"
        },
        {
          code: "289",
          fullName: "Ньютон",
          shortName: "Н",
          shortNameCode: "N"
        },
        {
          code: "290",
          fullName: "Герц",
          shortName: "Гц",
          shortNameCode: "Hz"
        },
        {
          code: "291",
          fullName: "Килогерц",
          shortName: "кГц",
          shortNameCode: "kHz"
        },
        {
          code: "292",
          fullName: "Мегагерц",
          shortName: "МГц",
          shortNameCode: "MHz"
        },
        {
          code: "294",
          fullName: "Паскаль",
          shortName: "Па",
          shortNameCode: "Pa"
        },
        {
          code: "296",
          fullName: "Сименс",
          shortName: "См",
          shortNameCode: "S"
        },
        {
          code: "297",
          fullName: "Килопаскаль",
          shortName: "кПа",
          shortNameCode: "kPa"
        },
        {
          code: "298",
          fullName: "Мегапаскаль",
          shortName: "МПа",
          shortNameCode: "MPa"
        },
        {
          code: "300",
          fullName: "Физическая атмосфера (101325 Па)",
          shortName: "атм",
          shortNameCode: "atm"
        },
        {
          code: "301",
          fullName: "Техническая атмосфера (98066,5 Па)",
          shortName: "ат",
          shortNameCode: "at"
        },
        {
          code: "302",
          fullName: "Гигабеккерель",
          shortName: "ГБк",
          shortNameCode: "GBq"
        },
        {
          code: "303",
          fullName: "Килобеккерель"
        },
        {
          code: "304",
          fullName: "Милликюри",
          shortName: "мКи",
          shortNameCode: "mCi"
        },
        {
          code: "305",
          fullName: "Кюри",
          shortName: "Ки",
          shortNameCode: "Ci"
        },
        {
          code: "306",
          fullName: "Грамм делящихся изотопов",
          shortName: "г Д/И",
          shortNameCode: "g fissile isotopes"
        },
        {
          code: "307",
          fullName: "Мегабеккерель"
        },
        {
          code: "308",
          fullName: "Миллибар",
          shortName: "мб",
          shortNameCode: "mbar"
        },
        {
          code: "309",
          fullName: "Бар",
          shortName: "бар",
          shortNameCode: "bar"
        },
        {
          code: "310",
          fullName: "Гектобар",
          shortName: "гб",
          shortNameCode: "hbar"
        },
        {
          code: "312",
          fullName: "Килобар",
          shortName: "кб",
          shortNameCode: "kbar"
        },
        {
          code: "313",
          fullName: "Тесла",
          shortName: "Тл",
          shortNameCode: "ТЛ"
        },
        {
          code: "314",
          fullName: "Фарад",
          shortName: "Ф",
          shortNameCode: "F"
        },
        {
          code: "316",
          fullName: "Киллограмм на кубический метр",
          shortName: "кг/м³",
          shortNameCode: "kg/m³"
        },
        {
          code: "317",
          fullName: "Килограмм на квадратный сантиметр",
          shortName: "кг/см²",
          shortNameCode: "КГ/СМ2"
        },
        {
          code: "320",
          fullName: "Моль"
        },
        {
          code: "323",
          fullName: "Беккерель",
          shortName: "Бк",
          shortNameCode: "Bq"
        },
        {
          code: "324",
          fullName: "Вебер",
          shortName: "Вб",
          shortNameCode: "Wb"
        },
        {
          code: "327",
          fullName: "Узел (миля/ч)",
          shortName: "уз",
          shortNameCode: "kn"
        },
        {
          code: "328",
          fullName: "Метр в секунду",
          shortName: "м/с",
          shortNameCode: "m/s"
        },
        {
          code: "330",
          fullName: "Оборот в секунду",
          shortName: "об/с",
          shortNameCode: "r/s"
        },
        {
          code: "331",
          fullName: "Оборот в минуту",
          shortName: "об/мин",
          shortNameCode: "r/min"
        },
        {
          code: "333",
          fullName: "Километр в час",
          shortName: "км/ч",
          shortNameCode: "km/h"
        },
        {
          code: "335",
          fullName: "Метр на секунду в квадрате",
          shortName: "м/с²",
          shortNameCode: "m/s²"
        },
        {
          code: "337",
          fullName: "Миллиметр водяного столба",
          shortName: "мм вод. ст",
          shortNameCode: "ММ ВОД СТ"
        },
        {
          code: "338",
          fullName: "Миллиметр ртутного столба",
          shortName: "мм рт. ст",
          shortNameCode: "ММ РТ СТ"
        },
        {
          code: "339",
          fullName: "Сантиметр водяного столба",
          shortName: "см вод. ст",
          shortNameCode: "СМ ВОД СТ"
        },
        {
          code: "340",
          fullName: "Грамм условного топлива на киловатт-час",
          shortName: "г у.т/кВт-ч",
          shortNameCode: "Г У.Т./КВТ-Ч"
        },
        {
          code: "341",
          fullName: "Килограмм условного топлива на гигакалорию",
          shortName: "кг у.т./Гкал",
          shortNameCode: "КГ У.Т./ГКАЛ"
        },
        {
          code: "349",
          fullName: "Кулон на килограмм",
          shortName: "Кл/кг",
          shortNameCode: "C/kg"
        },
        {
          code: "352",
          fullName: "Микросекунда",
          shortName: "мкс",
          shortNameCode: "МКС"
        },
        {
          code: "353",
          fullName: "Миллисекунда",
          shortName: "млс",
          shortNameCode: "МЛС"
        },
        {
          code: "354",
          fullName: "Секунда",
          shortName: "с",
          shortNameCode: "s"
        },
        {
          code: "355",
          fullName: "Минута",
          shortName: "мин",
          shortNameCode: "min"
        },
        {
          code: "356",
          fullName: "Час",
          shortName: "ч",
          shortNameCode: "h"
        },
        {
          code: "359",
          fullName: "Сутки",
          shortName: "сут; дн",
          shortNameCode: "d"
        },
        {
          code: "360",
          fullName: "Неделя",
          shortName: "нед",
          shortNameCode: "-"
        },
        {
          code: "361",
          fullName: "Декада",
          shortName: "дек",
          shortNameCode: "-"
        },
        {
          code: "362",
          fullName: "Месяц",
          shortName: "мес",
          shortNameCode: "-"
        },
        {
          code: "364",
          fullName: "Квартал",
          shortName: "кварт",
          shortNameCode: "-"
        },
        {
          code: "365",
          fullName: "Полугодие",
          shortName: "полгода",
          shortNameCode: "-"
        },
        {
          code: "366",
          fullName: "Год",
          shortName: "г; лет",
          shortNameCode: "a"
        },
        {
          code: "368",
          fullName: "Десятилетие",
          shortName: "деслет",
          shortNameCode: "-"
        },
        {
          code: "383",
          fullName: "Рубль",
          shortName: "руб",
          shortNameCode: "РУБ"
        },
        {
          code: "384",
          fullName: "Тысяча рублей",
          shortName: "10³ руб",
          shortNameCode: "ТЫС РУБ"
        },
        {
          code: "385",
          fullName: "Миллион рублей",
          shortName: "106 руб",
          shortNameCode: "МЛН РУБ"
        },
        {
          code: "386",
          fullName: "Миллиард рублей",
          shortName: "109 руб",
          shortNameCode: "МЛРД РУБ"
        },
        {
          code: "387",
          fullName: "Триллион рублей",
          shortName: "1012 руб",
          shortNameCode: "ТРИЛЛ РУБ"
        },
        {
          code: "388",
          fullName: "Квадрильон рублей",
          shortName: "1015 руб",
          shortNameCode: "КВАДР РУБ"
        },
        {
          code: "414",
          fullName: "Пассажиро-километр",
          shortName: "пасс.км",
          shortNameCode: "ПАСС.КМ"
        },
        {
          code: "421",
          fullName: "Пассажирское место (пассажирских мест)",
          shortName: "пасс. мест",
          shortNameCode: "ПАСС МЕСТ"
        },
        {
          code: "423",
          fullName: "Тысяча пассажиро-километров",
          shortName: "10³пасс.км",
          shortNameCode: "ТЫС ПАСС.КМ"
        },
        {
          code: "424",
          fullName: "Миллион пассажиро-километров",
          shortName: "106 пасс. км",
          shortNameCode: "МЛН ПАСС.КМ"
        },
        {
          code: "427",
          fullName: "Пассажиропоток",
          shortName: "пасс.поток",
          shortNameCode: "ПАСС.ПОТОК"
        },
        {
          code: "428",
          fullName: "Кубический метр-километр",
          shortName: "м³ · км",
          shortNameCode: "М3 · КМ"
        },
        {
          code: "449",
          fullName: "Тонно-километр",
          shortName: "т.км",
          shortNameCode: "Т.КМ"
        },
        {
          code: "450",
          fullName: "Тысяча тонно-километров",
          shortName: "10³ т.км",
          shortNameCode: "ТЫС Т.КМ"
        },
        {
          code: "451",
          fullName: "Миллион тонно-километров",
          shortName: "106 т. км",
          shortNameCode: "МЛН Т.КМ"
        },
        {
          code: "479",
          fullName: "Тысяча наборов",
          shortName: "10³ набор",
          shortNameCode: "ТЫС НАБОР"
        },
        {
          code: "499",
          fullName: "Килограмм в секунду",
          shortName: "кг/с",
          shortNameCode: "-"
        },
        {
          code: "508",
          fullName: "Тысяча метров кубических в час"
        },
        {
          code: "509",
          fullName: "Километр в сутки",
          shortName: "км/сут",
          shortNameCode: "КМ/СУТ"
        },
        {
          code: "510",
          fullName: "Грамм на киловатт-час",
          shortName: "г/кВт.ч",
          shortNameCode: "Г/КВТ.Ч"
        },
        {
          code: "511",
          fullName: "Килограмм на гигакалорию",
          shortName: "кг/Гкал",
          shortNameCode: "КГ/ГИГАКАЛ"
        },
        {
          code: "512",
          fullName: "Тонно-номер",
          shortName: "т.ном",
          shortNameCode: "Т.НОМ"
        },
        {
          code: "513",
          fullName: "Автотонна",
          shortName: "авто т",
          shortNameCode: "АВТО Т"
        },
        {
          code: "514",
          fullName: "Тонна тяги",
          shortName: "т.тяги",
          shortNameCode: "Т ТЯГИ"
        },
        {
          code: "515",
          fullName: "Дедвейт-тонна",
          shortName: "дедвейт.т",
          shortNameCode: "ДЕДВЕЙТ.Т"
        },
        {
          code: "516",
          fullName: "Тонна-танид",
          shortName: "т.танид",
          shortNameCode: "Т.ТАНИД"
        },
        {
          code: "521",
          fullName: "Человек на квадратный метр",
          shortName: "чел/м²",
          shortNameCode: "ЧЕЛ/М2"
        },
        {
          code: "522",
          fullName: "Человек на квадратный километр",
          shortName: "чел/км²",
          shortNameCode: "ЧЕЛ/КМ2"
        },
        {
          code: "533",
          fullName: "Тонна пара в час",
          shortName: "т пар/ч",
          shortNameCode: "-"
        },
        {
          code: "534",
          fullName: "Тонна в час",
          shortName: "т/ч",
          shortNameCode: "Т/Ч"
        },
        {
          code: "535",
          fullName: "Тонна в сутки",
          shortName: "т/сут",
          shortNameCode: "Т/СУТ"
        },
        {
          code: "536",
          fullName: "Тонна в смену",
          shortName: "т/смен",
          shortNameCode: "Т/СМЕН"
        },
        {
          code: "537",
          fullName: "Тысяча тонн в сезон",
          shortName: "10³ т/сез",
          shortNameCode: "ТЫС Т/СЕЗ"
        },
        {
          code: "538",
          fullName: "Тысяча тонн в год",
          shortName: "10³ т/год",
          shortNameCode: "ТЫС Т/ГОД"
        },
        {
          code: "540",
          fullName: "Человеко-день",
          shortName: "чел.дн",
          shortNameCode: "ЧЕЛ.ДН"
        },
        {
          code: "541",
          fullName: "Тысяча человеко-дней",
          shortName: "10³ чел.дн",
          shortNameCode: "ТЫС ЧЕЛ.ДН"
        },
        {
          code: "542",
          fullName: "Тысяча человеко-часов",
          shortName: "10³ чел.ч",
          shortNameCode: "ТЫС ЧЕЛ.Ч"
        },
        {
          code: "543",
          fullName: "Тысяча условных банок в смену",
          shortName: "10³ усл. банк/смен",
          shortNameCode: "ТЫС УСЛ БАНК/СМЕН"
        },
        {
          code: "544",
          fullName: "Миллион единиц в год",
          shortName: "106 ед/год",
          shortNameCode: "МЛН ЕД/ГОД"
        },
        {
          code: "545",
          fullName: "Посещение в смену",
          shortName: "посещ/смен",
          shortNameCode: "ПОСЕЩ/СМЕН"
        },
        {
          code: "546",
          fullName: "Тысяча посещений в смену",
          shortName: "10³ посещ/смен",
          shortNameCode: "ТЫС ПОСЕЩ/ СМЕН"
        },
        {
          code: "547",
          fullName: "Пара в смену",
          shortName: "пар/смен",
          shortNameCode: "ПАР/СМЕН"
        },
        {
          code: "548",
          fullName: "Тысяча пар в смену",
          shortName: "10³ пар/смен",
          shortNameCode: "ТЫС ПАР/СМЕН"
        },
        {
          code: "550",
          fullName: "Миллион тонн в год",
          shortName: "106 т/год",
          shortNameCode: "МЛН Т/ГОД"
        },
        {
          code: "552",
          fullName: "Тонна переработки в сутки",
          shortName: "т перераб/сут",
          shortNameCode: "Т ПЕРЕРАБ/СУТ"
        },
        {
          code: "553",
          fullName: "Тысяча тонн переработки в сутки",
          shortName: "10³ т перераб/сут",
          shortNameCode: "ТЫС Т ПЕРЕРАБ/СУТ"
        },
        {
          code: "554",
          fullName: "Центнер переработки в сутки",
          shortName: "ц перераб/сут",
          shortNameCode: "Ц ПЕРЕРАБ/СУТ"
        },
        {
          code: "555",
          fullName: "Тысяча центнеров переработки в сутки",
          shortName: "10³ ц перераб/сут",
          shortNameCode: "ТЫС Ц ПЕРЕРАБ/СУТ"
        },
        {
          code: "556",
          fullName: "Тысяча голов в год",
          shortName: "10³ гол/год",
          shortNameCode: "ТЫС ГОЛ/ГОД"
        },
        {
          code: "557",
          fullName: "Миллион голов в год",
          shortName: "106 гол/год",
          shortNameCode: "МЛН ГОЛ/ГОД"
        },
        {
          code: "558",
          fullName: "Тысяча птицемест",
          shortName: "10³ птицемест",
          shortNameCode: "ТЫС ПТИЦЕ-МЕСТ"
        },
        {
          code: "559",
          fullName: "Тысяча кур-несушек",
          shortName: "10³ кур. несуш",
          shortNameCode: "ТЫС КУР. НЕСУШ"
        },
        {
          code: "561",
          fullName: "Тысяча тонн пара в час",
          shortName: "10³ т пар/ч",
          shortNameCode: "ТЫС Т ПАР/Ч"
        },
        {
          code: "562",
          fullName: "Тысяча прядильных веретен",
          shortName: "10³ пряд.верет",
          shortNameCode: "ТЫС ПРЯД ВЕРЕТ"
        },
        {
          code: "563",
          fullName: "Тысяча прядильных мест",
          shortName: "10³ пряд.мест",
          shortNameCode: "ТЫС ПРЯД МЕСТ"
        },
        {
          code: "596",
          fullName: "Кубический метр в секунду",
          shortName: "м³/с",
          shortNameCode: "m3/s"
        },
        {
          code: "598",
          fullName: "Кубический метр в час",
          shortName: "м³/ч",
          shortNameCode: "m3/h"
        },
        {
          code: "599",
          fullName: "Тысяча кубических метров в сутки",
          shortName: "10³ м³/сут",
          shortNameCode: "-"
        },
        {
          code: "616",
          fullName: "Бобина",
          shortName: "боб",
          shortNameCode: "-"
        },
        {
          code: "625",
          fullName: "Лист",
          shortName: "л.",
          shortNameCode: "-"
        },
        {
          code: "626",
          fullName: "Сто листов",
          shortName: "100 л.",
          shortNameCode: "-"
        },
        {
          code: "630",
          fullName: "Тысяча стандартных условных кирпичей",
          shortName: "тыс станд. усл. кирп",
          shortNameCode: "-"
        },
        {
          code: "639",
          fullName: "Доза",
          shortName: "доз",
          shortNameCode: "ДОЗ"
        },
        {
          code: "640",
          fullName: "Тысяча доз",
          shortName: "10³ доз",
          shortNameCode: "ТЫС ДОЗ"
        },
        {
          code: "641",
          fullName: "Дюжина (12 шт.)",
          shortName: "дюжина",
          shortNameCode: "Doz; 12"
        },
        {
          code: "642",
          fullName: "Единица",
          shortName: "ед",
          shortNameCode: "ЕД"
        },
        {
          code: "643",
          fullName: "Тысяча единиц",
          shortName: "10³ ед",
          shortNameCode: "ТЫС ЕД"
        },
        {
          code: "644",
          fullName: "Миллион единиц",
          shortName: "106 ед",
          shortNameCode: "МЛН ЕД"
        },
        {
          code: "657",
          fullName: "Изделие",
          shortName: "изд",
          shortNameCode: "-"
        },
        {
          code: "661",
          fullName: "Канал",
          shortName: "канал",
          shortNameCode: "КАНАЛ"
        },
        {
          code: "673",
          fullName: "Тысяча комплектов",
          shortName: "10³ компл",
          shortNameCode: "ТЫС КОМПЛ"
        },
        {
          code: "683",
          fullName: "Сто ящиков",
          shortName: "100 ящ.",
          shortNameCode: "Hbx"
        },
        {
          code: "698",
          fullName: "Место",
          shortName: "мест",
          shortNameCode: "МЕСТ"
        },
        {
          code: "699",
          fullName: "Тысяча мест",
          shortName: "10³ мест",
          shortNameCode: "ТЫС МЕСТ"
        },
        {
          code: "704",
          fullName: "Набор",
          shortName: "набор",
          shortNameCode: "-"
        },
        {
          code: "709",
          fullName: "Тысяча номеров",
          shortName: "10³ ном",
          shortNameCode: "ТЫС НОМ"
        },
        {
          code: "715",
          fullName: "Пара (2 шт.)",
          shortName: "пар",
          shortNameCode: "pr; 2"
        },
        {
          code: "724",
          fullName: "Тысяча гектаров порций",
          shortName: "10³ га порц",
          shortNameCode: "ТЫС ГА ПОРЦ"
        },
        {
          code: "728",
          fullName: "Пачка",
          shortName: "пач",
          shortNameCode: "ПАЧ"
        },
        {
          code: "729",
          fullName: "Тысяча пачек",
          shortName: "10³ пач",
          shortNameCode: "ТЫС ПАЧ"
        },
        {
          code: "730",
          fullName: "Два десятка",
          shortName: "20",
          shortNameCode: "20"
        },
        {
          code: "732",
          fullName: "Десять пар",
          shortName: "10 пар",
          shortNameCode: "-"
        },
        {
          code: "733",
          fullName: "Дюжина пар",
          shortName: "дюжина пар",
          shortNameCode: "-"
        },
        {
          code: "734",
          fullName: "Посылка",
          shortName: "посыл",
          shortNameCode: "-"
        },
        {
          code: "735",
          fullName: "Часть",
          shortName: "часть",
          shortNameCode: "-"
        },
        {
          code: "736",
          fullName: "Рулон",
          shortName: "рул",
          shortNameCode: "-"
        },
        {
          code: "737",
          fullName: "Дюжина рулонов",
          shortName: "дюжина рул",
          shortNameCode: "-"
        },
        {
          code: "740",
          fullName: "Дюжина штук",
          shortName: "дюжина шт",
          shortNameCode: "-"
        },
        {
          code: "744",
          fullName: "Процент",
          shortName: "%",
          shortNameCode: "ПРОЦ"
        },
        {
          code: "745",
          fullName: "Элемент",
          shortName: "элем",
          shortNameCode: "CI"
        },
        {
          code: "746",
          fullName: "Промилле (0,1 процента)",
          shortName: "промилле",
          shortNameCode: "ПРОМИЛЛЕ"
        },
        {
          code: "751",
          fullName: "Тысяча рулонов",
          shortName: "10³ рул",
          shortNameCode: "ТЫС РУЛ"
        },
        {
          code: "761",
          fullName: "Тысяча станов",
          shortName: "10³ стан",
          shortNameCode: "ТЫС СТАН"
        },
        {
          code: "762",
          fullName: "Станция",
          shortName: "станц",
          shortNameCode: "СТАНЦ"
        },
        {
          code: "775",
          fullName: "Тысяча тюбиков",
          shortName: "10³ тюбик",
          shortNameCode: "ТЫС ТЮБИК"
        },
        {
          code: "776",
          fullName: "Тысяча условных тубов",
          shortName: "10³ усл.туб",
          shortNameCode: "ТЫС УСЛ ТУБ"
        },
        {
          code: "778",
          fullName: "Упаковка",
          shortName: "упак",
          shortNameCode: "-"
        },
        {
          code: "779",
          fullName: "Миллион упаковок",
          shortName: "106 упак",
          shortNameCode: "МЛН УПАК"
        },
        {
          code: "780",
          fullName: "Дюжина упаковок",
          shortName: "дюжина упак",
          shortNameCode: "-"
        },
        {
          code: "781",
          fullName: "Сто упаковок",
          shortName: "100 упак",
          shortNameCode: "-"
        },
        {
          code: "782",
          fullName: "Тысяча упаковок",
          shortName: "10³ упак",
          shortNameCode: "ТЫС УПАК"
        },
        {
          code: "792",
          fullName: "Человек",
          shortName: "чел",
          shortNameCode: "ЧЕЛ"
        },
        {
          code: "793",
          fullName: "Тысяча человек",
          shortName: "10³ чел",
          shortNameCode: "ТЫС ЧЕЛ"
        },
        {
          code: "794",
          fullName: "Миллион человек",
          shortName: "106 чел",
          shortNameCode: "МЛН ЧЕЛ"
        },
        {
          code: "797",
          fullName: "Сто штук",
          shortName: "100 шт",
          shortNameCode: "100"
        },
        {
          code: "798",
          fullName: "Тысяча штук",
          shortName: "тыс. шт; 1000 шт",
          shortNameCode: "1000"
        },
        {
          code: "799",
          fullName: "Миллион штук",
          shortName: "106 шт",
          shortNameCode: "106"
        },
        {
          code: "800",
          fullName: "Миллиард штук",
          shortName: "109 шт",
          shortNameCode: "109"
        },
        {
          code: "801",
          fullName: "Биллион штук (Европа); триллион штук",
          shortName: "1012 шт",
          shortNameCode: "1012"
        },
        {
          code: "802",
          fullName: "Квинтильон штук (Европа)",
          shortName: "1018 шт",
          shortNameCode: "1018"
        },
        {
          code: "808",
          fullName: "Миллион экземпляров",
          shortName: "106 экз",
          shortNameCode: "МЛН ЭКЗ"
        },
        {
          code: "810",
          fullName: "Ячейка",
          shortName: "яч",
          shortNameCode: "ЯЧ"
        },
        {
          code: "812",
          fullName: "Ящик",
          shortName: "ящ",
          shortNameCode: "ЯЩ"
        },
        {
          code: "820",
          fullName: "Крепость спирта по массе",
          shortName: "креп. спирта по массе",
          shortNameCode: "% mds"
        },
        {
          code: "821",
          fullName: "Крепость спирта по объему",
          shortName: "креп. спирта по объему",
          shortNameCode: "% vol"
        },
        {
          code: "831",
          fullName: "Литр чистого (100 %) спирта",
          shortName: "л 100% спирта",
          shortNameCode: "-"
        },
        {
          code: "833",
          fullName: "Гектолитр чистого (100 %) спирта",
          shortName: "Гл 100% спирта",
          shortNameCode: "-"
        },
        {
          code: "836",
          fullName: "Голова",
          shortName: "гол",
          shortNameCode: "ГОЛ"
        },
        {
          code: "837",
          fullName: "Тысяча пар",
          shortName: "10³ пар",
          shortNameCode: "ТЫС ПАР"
        },
        {
          code: "838",
          fullName: "Миллион пар",
          shortName: "106 пар",
          shortNameCode: "МЛН ПАР"
        },
        {
          code: "839",
          fullName: "Комплект",
          shortName: "компл",
          shortNameCode: "КОМПЛ"
        },
        {
          code: "840",
          fullName: "Секция",
          shortName: "секц",
          shortNameCode: "СЕКЦ"
        },
        {
          code: "841",
          fullName: "Килограмм пероксида водорода",
          shortName: "кг H2О2",
          shortNameCode: "-"
        },
        {
          code: "845",
          fullName: "Килограмм 90 %-го сухого вещества",
          shortName: "кг 90% с/в",
          shortNameCode: "-"
        },
        {
          code: "847",
          fullName: "Тонна 90 %-го сухого вещества",
          shortName: "т 90% с/в",
          shortNameCode: "-"
        },
        {
          code: "852",
          fullName: "Килограмм оксида калия",
          shortName: "кг К2О",
          shortNameCode: "-"
        },
        {
          code: "859",
          fullName: "Килограмм гидроксида калия",
          shortName: "кг КОН",
          shortNameCode: "-"
        },
        {
          code: "861",
          fullName: "Килограмм азота",
          shortName: "кг N",
          shortNameCode: "-"
        },
        {
          code: "863",
          fullName: "Килограмм гидроксида натрия",
          shortName: "кг NaOH",
          shortNameCode: "-"
        },
        {
          code: "865",
          fullName: "Килограмм пятиокиси фосфора",
          shortName: "кг Р2О5",
          shortNameCode: "-"
        },
        {
          code: "867",
          fullName: "Килограмм урана",
          shortName: "кг U",
          shortNameCode: "-"
        },
        {
          code: "868",
          fullName: "Бутылка",
          shortName: "бут",
          shortNameCode: "БУТ"
        },
        {
          code: "869",
          fullName: "Тысяча бутылок",
          shortName: "10³ бут",
          shortNameCode: "ТЫС БУТ"
        },
        {
          code: "870",
          fullName: "Ампула",
          shortName: "ампул",
          shortNameCode: "АМПУЛ"
        },
        {
          code: "871",
          fullName: "Тысяча ампул",
          shortName: "10³ ампул",
          shortNameCode: "ТЫС АМПУЛ"
        },
        {
          code: "872",
          fullName: "Флакон",
          shortName: "флак",
          shortNameCode: "ФЛАК"
        },
        {
          code: "873",
          fullName: "Тысяча флаконов",
          shortName: "10³ флак",
          shortNameCode: "ТЫС ФЛАК"
        },
        {
          code: "874",
          fullName: "Тысяча тубов",
          shortName: "10³ туб",
          shortNameCode: "ТЫС ТУБ"
        },
        {
          code: "875",
          fullName: "Тысяча коробок",
          shortName: "10³ кор",
          shortNameCode: "ТЫС КОР"
        },
        {
          code: "876",
          fullName: "Условная единица",
          shortName: "усл. ед",
          shortNameCode: "УСЛ ЕД"
        },
        {
          code: "877",
          fullName: "Тысяча условных единиц",
          shortName: "10³ усл. ед",
          shortNameCode: "ТЫС УСЛ ЕД"
        },
        {
          code: "878",
          fullName: "Миллион условных единиц",
          shortName: "106 усл. ед",
          shortNameCode: "МЛН УСЛ ЕД"
        },
        {
          code: "879",
          fullName: "Условная штука",
          shortName: "усл. шт",
          shortNameCode: "УСЛ ШТ"
        },
        {
          code: "880",
          fullName: "Тысяча условных штук",
          shortName: "10³ усл. шт",
          shortNameCode: "ТЫС УСЛ ШТ"
        },
        {
          code: "881",
          fullName: "Условная банка",
          shortName: "усл. банк",
          shortNameCode: "УСЛ БАНК"
        },
        {
          code: "882",
          fullName: "Тысяча условных банок",
          shortName: "10³ усл. банк",
          shortNameCode: "ТЫС УСЛ БАНК"
        },
        {
          code: "883",
          fullName: "Миллион условных банок",
          shortName: "106 усл. банк",
          shortNameCode: "МЛН УСЛ БАНК"
        },
        {
          code: "884",
          fullName: "Условный кусок",
          shortName: "усл. кус",
          shortNameCode: "УСЛ КУС"
        },
        {
          code: "885",
          fullName: "Тысяча условных кусков",
          shortName: "10³ усл. кус",
          shortNameCode: "ТЫС УСЛ КУС"
        },
        {
          code: "886",
          fullName: "Миллион условных кусков",
          shortName: "106 усл. кус",
          shortNameCode: "МЛН УСЛ КУС"
        },
        {
          code: "887",
          fullName: "Условный ящик",
          shortName: "усл. ящ",
          shortNameCode: "УСЛ ЯЩ"
        },
        {
          code: "888",
          fullName: "Тысяча условных ящиков",
          shortName: "10³ усл. ящ",
          shortNameCode: "ТЫС УСЛ ЯЩ"
        },
        {
          code: "889",
          fullName: "Условная катушка",
          shortName: "усл. кат",
          shortNameCode: "УСЛ КАТ"
        },
        {
          code: "890",
          fullName: "Тысяча условных катушек",
          shortName: "10³ усл. кат",
          shortNameCode: "ТЫС УСЛ КАТ"
        },
        {
          code: "891",
          fullName: "Условная плитка",
          shortName: "усл. плит",
          shortNameCode: "УСЛ ПЛИТ"
        },
        {
          code: "892",
          fullName: "Тысяча условных плиток",
          shortName: "10³ усл. плит",
          shortNameCode: "ТЫС УСЛ ПЛИТ"
        },
        {
          code: "893",
          fullName: "Условный кирпич",
          shortName: "усл. кирп",
          shortNameCode: "УСЛ КИРП"
        },
        {
          code: "894",
          fullName: "Тысяча условных кирпичей",
          shortName: "10³ усл. кирп",
          shortNameCode: "ТЫС УСЛ КИРП"
        },
        {
          code: "895",
          fullName: "Миллион условных кирпичей",
          shortName: "106 усл. кирп",
          shortNameCode: "МЛН УСЛ КИРП"
        },
        {
          code: "896",
          fullName: "Семья",
          shortName: "семей",
          shortNameCode: "СЕМЕЙ"
        },
        {
          code: "897",
          fullName: "Тысяча семей",
          shortName: "10³ семей",
          shortNameCode: "ТЫС СЕМЕЙ"
        },
        {
          code: "898",
          fullName: "Миллион семей",
          shortName: "106 семей",
          shortNameCode: "МЛН СЕМЕЙ"
        },
        {
          code: "899",
          fullName: "Домохозяйство",
          shortName: "домхоз",
          shortNameCode: "ДОМХОЗ"
        },
        {
          code: "900",
          fullName: "Тысяча домохозяйств",
          shortName: "10³ домхоз",
          shortNameCode: "ТЫС ДОМХОЗ"
        },
        {
          code: "901",
          fullName: "Миллион домохозяйств",
          shortName: "106 домхоз",
          shortNameCode: "МЛН ДОМХОЗ"
        },
        {
          code: "902",
          fullName: "Ученическое место",
          shortName: "учен. мест",
          shortNameCode: "УЧЕН МЕСТ"
        },
        {
          code: "903",
          fullName: "Тысяча ученических мест",
          shortName: "10³ учен. мест",
          shortNameCode: "ТЫС УЧЕН МЕСТ"
        },
        {
          code: "904",
          fullName: "Рабочее место",
          shortName: "раб. мест",
          shortNameCode: "РАБ МЕСТ"
        },
        {
          code: "905",
          fullName: "Тысяча рабочих мест",
          shortName: "10³ раб. мест",
          shortNameCode: "ТЫС РАБ МЕСТ"
        },
        {
          code: "906",
          fullName: "Посадочное место",
          shortName: "посад. мест",
          shortNameCode: "ПОСАД МЕСТ"
        },
        {
          code: "907",
          fullName: "Тысяча посадочных мест",
          shortName: "10³ посад. мест",
          shortNameCode: "ТЫС ПОСАД МЕСТ"
        },
        {
          code: "908",
          fullName: "Номер",
          shortName: "ном",
          shortNameCode: "НОМ"
        },
        {
          code: "909",
          fullName: "Квартира",
          shortName: "кварт",
          shortNameCode: "КВАРТ"
        },
        {
          code: "910",
          fullName: "Тысяча квартир",
          shortName: "10³ кварт",
          shortNameCode: "ТЫС КВАРТ"
        },
        {
          code: "911",
          fullName: "Койка",
          shortName: "коек",
          shortNameCode: "КОЕК"
        },
        {
          code: "912",
          fullName: "Тысяча коек",
          shortName: "10³ коек",
          shortNameCode: "ТЫС КОЕК"
        },
        {
          code: "913",
          fullName: "Том книжного фонда",
          shortName: "том книжн. фонд",
          shortNameCode: "ТОМ КНИЖН ФОНД"
        },
        {
          code: "914",
          fullName: "Тысяча томов книжного фонда",
          shortName: "10³ том. книжн. фонд",
          shortNameCode: "ТЫС ТОМ КНИЖН ФОНД"
        },
        {
          code: "915",
          fullName: "Условный ремонт",
          shortName: "усл. рем",
          shortNameCode: "УСЛ РЕМ"
        },
        {
          code: "916",
          fullName: "Условный ремонт в год",
          shortName: "усл. рем/год",
          shortNameCode: "УСЛ РЕМ/ГОД"
        },
        {
          code: "917",
          fullName: "Смена",
          shortName: "смен",
          shortNameCode: "СМЕН"
        },
        {
          code: "918",
          fullName: "Лист авторский",
          shortName: "л. авт",
          shortNameCode: "ЛИСТ АВТ"
        },
        {
          code: "920",
          fullName: "Лист печатный",
          shortName: "л. печ",
          shortNameCode: "ЛИСТ ПЕЧ"
        },
        {
          code: "921",
          fullName: "Лист учетно-издательский",
          shortName: "л. уч.-изд",
          shortNameCode: "ЛИСТ УЧ.ИЗД"
        },
        {
          code: "922",
          fullName: "Знак",
          shortName: "знак",
          shortNameCode: "ЗНАК"
        },
        {
          code: "923",
          fullName: "Слово",
          shortName: "слово",
          shortNameCode: "СЛОВО"
        },
        {
          code: "924",
          fullName: "Символ",
          shortName: "символ",
          shortNameCode: "СИМВОЛ"
        },
        {
          code: "925",
          fullName: "Условная труба",
          shortName: "усл. труб",
          shortNameCode: "УСЛ ТРУБ"
        },
        {
          code: "930",
          fullName: "Тысяча пластин",
          shortName: "10³ пласт",
          shortNameCode: "ТЫС ПЛАСТ"
        },
        {
          code: "937",
          fullName: "Миллион доз",
          shortName: "106 доз",
          shortNameCode: "МЛН ДОЗ"
        },
        {
          code: "949",
          fullName: "Миллион листов-оттисков",
          shortName: "10³ лист.оттиск",
          shortNameCode: "МЛН ЛИСТ.ОТТИСК"
        },
        {
          code: "950",
          fullName: "Вагоно (машино)-день",
          shortName: "ваг (маш).дн",
          shortNameCode: "ВАГ (МАШ).ДН"
        },
        {
          code: "951",
          fullName: "Тысяча вагоно (машино)-часов",
          shortName: "10³ ваг (маш).ч",
          shortNameCode: "ТЫС ВАГ (МАШ).Ч"
        },
        {
          code: "952",
          fullName: "Тысяча вагоно (машино)-километров",
          shortName: "10³ ваг (маш).км",
          shortNameCode: "ТЫС ВАГ (МАШ).КМ"
        },
        {
          code: "953",
          fullName: "Тысяча место-километров",
          shortName: "10³ мест.км",
          shortNameCode: "ТЫС МЕСТ.КМ"
        },
        {
          code: "954",
          fullName: "Вагоно-сутки",
          shortName: "ваг.сут",
          shortNameCode: "ВАГ.СУТ"
        },
        {
          code: "955",
          fullName: "Тысяча поездо-часов",
          shortName: "10³ поезд.ч",
          shortNameCode: "ТЫС ПОЕЗД.Ч"
        },
        {
          code: "956",
          fullName: "Тысяча поездо-километров",
          shortName: "10³ поезд.км",
          shortNameCode: "ТЫС ПОЕЗД.КМ"
        },
        {
          code: "957",
          fullName: "Тысяча тонно-миль",
          shortName: "10³ т.миль",
          shortNameCode: "ТЫС Т.МИЛЬ"
        },
        {
          code: "958",
          fullName: "Тысяча пассажиро-миль",
          shortName: "10³ пасс.миль",
          shortNameCode: "ТЫС ПАСС.МИЛЬ"
        },
        {
          code: "959",
          fullName: "Автомобиле-день",
          shortName: "автомоб.дн",
          shortNameCode: "АВТОМОБ.ДН"
        },
        {
          code: "960",
          fullName: "Тысяча автомобиле-тонно-дней",
          shortName: "10³ автомоб.т.дн",
          shortNameCode: "ТЫС АВТОМОБ.Т.ДН"
        },
        {
          code: "961",
          fullName: "Тысяча автомобиле-часов",
          shortName: "10³ автомоб.ч",
          shortNameCode: "ТЫС АВТОМОБ.Ч"
        },
        {
          code: "962",
          fullName: "Тысяча автомобиле-место-дней",
          shortName: "10³ автомоб.мест. дн",
          shortNameCode: "ТЫС АВТОМОБ.МЕСТ. ДН"
        },
        {
          code: "963",
          fullName: "Приведенный час",
          shortName: "привед.ч",
          shortNameCode: "ПРИВЕД.Ч"
        },
        {
          code: "964",
          fullName: "Самолето-километр",
          shortName: "самолет.км",
          shortNameCode: "САМОЛЕТ.КМ"
        },
        {
          code: "965",
          fullName: "Тысяча километров",
          shortName: "10³ км",
          shortNameCode: "ТЫС КМ"
        },
        {
          code: "966",
          fullName: "Тысяча тоннаже-рейсов",
          shortName: "10³ тоннаж. рейс",
          shortNameCode: "ТЫС ТОННАЖ. РЕЙС"
        },
        {
          code: "967",
          fullName: "Миллион тонно-миль",
          shortName: "106 т. миль",
          shortNameCode: "МЛН Т. МИЛЬ"
        },
        {
          code: "968",
          fullName: "Миллион пассажиро-миль",
          shortName: "106 пасс. миль",
          shortNameCode: "МЛН ПАСС. МИЛЬ"
        },
        {
          code: "969",
          fullName: "Миллион тоннаже-миль",
          shortName: "106 тоннаж. миль",
          shortNameCode: "МЛН ТОННАЖ. МИЛЬ"
        },
        {
          code: "970",
          fullName: "Миллион пассажиро-место-миль",
          shortName: "106 пасс. мест. миль",
          shortNameCode: "МЛН ПАСС. МЕСТ. МИЛЬ"
        },
        {
          code: "971",
          fullName: "Кормо-день",
          shortName: "корм. дн",
          shortNameCode: "КОРМ. ДН"
        },
        {
          code: "972",
          fullName: "Центнер кормовых единиц",
          shortName: "ц корм ед",
          shortNameCode: "Ц КОРМ ЕД"
        },
        {
          code: "973",
          fullName: "Тысяча автомобиле-километров",
          shortName: "10³ автомоб. км",
          shortNameCode: "ТЫС АВТОМОБ. КМ"
        },
        {
          code: "974",
          fullName: "Тысяча тоннаже-суток",
          shortName: "10³ тоннаж. сут",
          shortNameCode: "ТЫС ТОННАЖ. СУТ"
        },
        {
          code: "975",
          fullName: "Суго-сутки",
          shortName: "суго. сут.",
          shortNameCode: "СУГО. СУТ"
        },
        {
          code: "976",
          fullName: "Штук в 20-футовом эквиваленте (ДФЭ)",
          shortName: "штук в 20-футовом эквиваленте",
          shortNameCode: "ШТ В 20 ФУТ ЭКВИВ"
        },
        {
          code: "977",
          fullName: "Канало-километр",
          shortName: "канал. км",
          shortNameCode: "КАНАЛ. КМ"
        },
        {
          code: "978",
          fullName: "Канало-концы",
          shortName: "канал. конц",
          shortNameCode: "КАНАЛ. КОНЦ"
        },
        {
          code: "979",
          fullName: "Тысяча экземпляров",
          shortName: "10³ экз",
          shortNameCode: "ТЫС ЭКЗ"
        },
        {
          code: "980",
          fullName: "Тысяча долларов",
          shortName: "10³ доллар",
          shortNameCode: "ТЫС ДОЛЛАР"
        },
        {
          code: "981",
          fullName: "Тысяча тонн кормовых единиц",
          shortName: "10³ корм ед",
          shortNameCode: "ТЫС Т КОРМ ЕД"
        },
        {
          code: "982",
          fullName: "Миллион тонн кормовых единиц",
          shortName: "106 корм ед",
          shortNameCode: "МЛН Т КОРМ ЕД"
        },
        {
          code: "983",
          fullName: "Судо-сутки",
          shortName: "суд.сут",
          shortNameCode: "СУД.СУТ"
        },
        {
          code: "984",
          fullName: "Центнеров с гектара"
        },
        {
          code: "985",
          fullName: "Тысяча голов"
        },
        {
          code: "986",
          fullName: "Тысяча краско-оттисков"
        },
        {
          code: "987",
          fullName: "Миллион краско-оттисков"
        },
        {
          code: "988",
          fullName: "Миллион условных плиток"
        },
        {
          code: "989",
          fullName: "Человек в час"
        },
        {
          code: "990",
          fullName: "Пассажиров в час"
        },
        {
          code: "991",
          fullName: "Пассажиро-миля"
        },
        {
          code: "2541",
          fullName: "Бит в секунду"
        },
        {
          code: "2543",
          fullName: "Килобит в секунду"
        },
        {
          code: "2545",
          fullName: "Мегабит в секунду"
        },
        {
          code: "2547",
          fullName: "Гигабит в секунду"
        },
        {
          code: "2551",
          fullName: "Байт в секунду"
        },
        {
          code: "2552",
          fullName: "Гигабайт в секунду"
        },
        {
          code: "2553",
          fullName: "Гигабайт"
        },
        {
          code: "2554",
          fullName: "Терабайт"
        },
        {
          code: "2555",
          fullName: "Петабайт"
        },
        {
          code: "2556",
          fullName: "Эксабайт"
        },
        {
          code: "2557",
          fullName: "Зеттабайт"
        },
        {
          code: "2558",
          fullName: "Йоттабайт"
        },
        {
          code: "2561",
          fullName: "Килобайт в секунду"
        },
        {
          code: "2571",
          fullName: "Мегабайт в секунду"
        },
        {
          code: "2581",
          fullName: "Эрланг"
        },
        {
          code: "2931",
          fullName: "Гигагерц"
        },
        {
          code: "3135",
          fullName: "Децибел"
        },
        {
          code: "3181",
          fullName: "Человеко-зиверт",
          shortName: "чел.-Зв",
          shortNameCode: "ЧЕЛ.-ЗВ"
        },
        {
          code: "3231",
          fullName: "Беккерель на метр кубический",
          shortName: "Бк/м³",
          shortNameCode: "БК/M3"
        },
        {
          code: "3831",
          fullName: "Рубль тонна"
        },
        {
          code: "3841",
          fullName: "Тысяча рублей на человека",
          shortName: "10³ руб/чел",
          shortNameCode: "ТЫС РУБ/ЧЕЛ"
        },
        {
          code: "5401",
          fullName: "Дето-день"
        },
        {
          code: "5423",
          fullName: "Человек в год"
        },
        {
          code: "5451",
          fullName: "Посещение"
        },
        {
          code: "5562",
          fullName: "Тысяча гнезд"
        },
        {
          code: "6421",
          fullName: "Единиц в год"
        },
        {
          code: "6422",
          fullName: "Вызов"
        },
        {
          code: "6423",
          fullName: "Посевная единица"
        },
        {
          code: "6424",
          fullName: "Штамм"
        },
        {
          code: "7923",
          fullName: "Абонент"
        },
        {
          code: "8361",
          fullName: "Особь"
        },
        {
          code: "9061",
          fullName: "Миллион гектаров"
        },
        {
          code: "9062",
          fullName: "Миллиард гектаров"
        },
        {
          code: "9111",
          fullName: "Койко-день"
        },
        {
          code: "9113",
          fullName: "Пациенто-день"
        },
        {
          code: "9245",
          fullName: "Запись"
        },
        {
          code: "9246",
          fullName: "Документ"
        },
        {
          code: "9491",
          fullName: "Лист-оттиск"
        },
        {
          code: "9501",
          fullName: "Вагоно (машино)-час"
        },
        {
          code: "9557",
          fullName: "Миллион голов"
        },
        {
          code: "9641",
          fullName: "Летный час"
        },
        {
          code: "9642",
          fullName: "Балл"
        },
        {
          code: "9805",
          fullName: "Доллар за тонну"
        },
        {
          code: "9822",
          fullName: "Миллион долларов",
          shortName: "106 евро",
          shortNameCode: "МЛН ЕВРО"
        },
        {
          code: "9822",
          fullName: "Миллион евро",
          shortName: "106 евро",
          shortNameCode: "МЛН ЕВРО"
        },
        {
          code: "9823",
          fullName: "Миллиард долларов",
          shortName: "109 евро",
          shortNameCode: "МЛРД ЕВРО"
        },
        {
          code: "9823",
          fullName: "Миллиард евро",
          shortName: "109 евро",
          shortNameCode: "МЛРД ЕВРО"
        },
        {
          code: "9910",
          fullName: "Международная единица биологической активности"
        },
        {
          code: "9911",
          fullName: "Тысяча международных единиц биологической активности"
        },
        {
          code: "9912",
          fullName: "Миллион международных единиц биологической активности"
        },
        {
          code: "9913",
          fullName: "Международная единица биологической активности на грамм"
        },
        {
          code: "9914",
          fullName: "Тысяча международных единиц биологической активности на грамм"
        },
        {
          code: "9915",
          fullName: "Миллион международных единиц биологической активности на грамм"
        },
        {
          code: "9916",
          fullName: "Международная единица биологической активности на миллилитр"
        },
        {
          code: "9917",
          fullName: "Тысяча международных единиц биологической активности на миллилитр"
        },
        {
          code: "9918",
          fullName: "Миллион международных единиц биологической активности на миллилитр"
        },
        {
          code: "9920",
          fullName: "Единица действия биологической активности"
        },
        {
          code: "9921",
          fullName: "Единица действия биологической активности на грамм"
        },
        {
          code: "9922",
          fullName: "Тысяча единиц действия биологической активности на грамм"
        },
        {
          code: "9923",
          fullName: "Единица действия биологической активности на микролитр"
        },
        {
          code: "9924",
          fullName: "Единица действия биологической активности на миллилитр"
        },
        {
          code: "9925",
          fullName: "Тысяча единиц действия биологической активности на миллилитр"
        },
        {
          code: "9926",
          fullName: "Миллион единиц действия биологической активности на миллилитр"
        },
        {
          code: "9927",
          fullName: "Единица действия биологической активности в сутки"
        },
        {
          code: "9930",
          fullName: "Антитоксическая единица"
        },
        {
          code: "9931",
          fullName: "Тысяча антитоксических единиц"
        },
        {
          code: "9940",
          fullName: "Антитрипсиновая единица"
        },
        {
          code: "9941",
          fullName: "Тысяча антитрипсиновых единиц"
        },
        {
          code: "9950",
          fullName: "Индекс Реактивности"
        },
        {
          code: "9951",
          fullName: "Индекс Реактивности на миллилитр"
        },
        {
          code: "9960",
          fullName: "Килобеккерель на миллилитр"
        },
        {
          code: "9961",
          fullName: "Мегабеккерель на миллилитр"
        },
        {
          code: "9962",
          fullName: "Мегабеккерель на метр квадратный"
        },
        {
          code: "9970",
          fullName: "Калликреиновая ингибирующая единица на миллилитр"
        },
        {
          code: "9971",
          fullName: "Тысяча калликреиновых ингибирующих единиц на миллилитр"
        },
        {
          code: "9980",
          fullName: "Миллион колониеобразующих единиц"
        },
        {
          code: "9981",
          fullName: "Миллион колониеобразующих единиц на пакет"
        },
        {
          code: "9982",
          fullName: "Миллиард колониеобразующих единиц"
        },
        {
          code: "9983",
          fullName: "Протеолитическая единица"
        },
        {
          code: "9985",
          fullName: "Микрограмм на миллилитр"
        },
        {
          code: "9986",
          fullName: "Микрограмм в сутки"
        },
        {
          code: "9987",
          fullName: "Микрограмм в час"
        },
        {
          code: "9988",
          fullName: "Микрограмм на дозу"
        },
        {
          code: "9990",
          fullName: "Миллимоль на миллилитр"
        },
        {
          code: "9991",
          fullName: "Миллимоль на литр"
        }
      ]
    },
    getUnitByCode(code) {
      return this.getUnits().find(x => x.code === code)
    },
    getUnitShortName(code) {
      const unit = this.getUnitByCode(code);

      if (!unit) { return code || ""; }

      return unit.shortName || unit.fullName || code || "";
    },
    getStatsUnitCode(code) {
      return String(code || "539") === "539" ? "539" : "796";
    },
    getStatsUnitShortName(code) {
      return this.getUnitShortName(this.getStatsUnitCode(code));
    },
    formatStatsUnitTotals(items, valueKey = "total_hours", unitKey = "unit_code") {
      const totalsByUnit = {};

      (items || []).forEach(item => {
        const unitCode = this.getStatsUnitCode(item[unitKey]);
        const value = Number(item[valueKey] || 0);

        totalsByUnit[unitCode] = (totalsByUnit[unitCode] || 0) + value;
      });

      return ["539", "796"]
        .filter(unitCode => Object.prototype.hasOwnProperty.call(totalsByUnit, unitCode))
        .map(unitCode => {
          const value = Math.round(totalsByUnit[unitCode] * 100) / 100;
          return `${new Intl.NumberFormat('ru-RU').format(value)} ${this.getUnitShortName(unitCode)}`;
        })
        .join("; ");
    },
    formatUnitTotals(items, valueKey = "total_hours", unitKey = "unit_code") {
      const totalsByUnit = {};

      (items || []).forEach(item => {
        const unitCode = item[unitKey] || "539";
        const value = Number(item[valueKey] || 0);

        totalsByUnit[unitCode] = (totalsByUnit[unitCode] || 0) + value;
      });

      return Object.keys(totalsByUnit)
        .map(unitCode => {
          const value = Math.round(totalsByUnit[unitCode] * 100) / 100;
          return `${new Intl.NumberFormat('ru-RU').format(value)} ${this.getUnitShortName(unitCode)}`;
        })
        .join("; ");
    }
  }
}




// WEBPACK FOOTER //
// ./src/utilites/unitStore.js